import React, { useState, useEffect } from "react";
import LabelInput from "../../Component/labelInput";
import PageTitle from "../../module/pageTitle";
import { InputField, Submitbtn } from "../../Component";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../store";
import { validateFullName, startsWithSpace, validateIsLettersAndDigitsOnly, validateIsDigitsAndDotOnly, emailCheck, validateDigitOnly } from "../../Utils/validators";
import AdminTable from "../../Component/adminTable";
import { addVendor, getCities, getstate, getTDSSectionList, vendorList, deleteVendor, updateVendor } from "./publicationSlice";
import DropDown from "../../Component/dropdown";
import AddMoreBtn from "../../Component/addMoreBtn";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { gstRateList } from "../../Utils/dataConstant";
import { showSnackbar, hideSnackbar } from "../../store/slices/snackbarSlice";
const Vendor = () => {
    const dispatch: Function = useDispatch<AppDispatch>();
    const initialVal = {
        serviceName: "",
        TDSSection: "",
        TDSRate: "",
        GSTRate: "",
    };
    const [isAdd, setIsAdd] = useState<boolean>(false);
    const [vendorsList, setVendorsList] = useState<string>("");
    const [vendorName, setVendorName] = useState<string>("");
    const [gstNumber, setGSTNumber] = useState<string>("");
    const [panNumber, setPANNumber] = useState<string>("");
    const [contactPerson, setContactPerson] = useState<string>("");
    const [contactNumber, setContactNumber] = useState<string>("");
    const [contactEmail, setContactEmail] = useState<string>("");
    const [address, setAddress] = useState<string>("");
    const [state, setState] = useState<any>("")
    const [stateList, setStateList] = useState<any>([])
    const [city, setCity] = useState<any>("");
    const [cityList, setCityList] = useState<any>([])
    const [officialcontactNumber, setOfficialContactNumber] = useState<string>("");
    const [officialEmail, setOfficialEmail] = useState<string>("");
    const [serviceArr, setServiceArr] = useState<any>([initialVal])
    const [vendorID, setVendorID] = useState<string>("");
    const [tdsSectionList, setTdsSectionList] = useState<any>([])
    const [isEditMode, setisEditMode] = useState<Boolean>(false);
    useEffect(() => {
        getData();
        dispatch(
            getstate({
                callback: (res: any) => {
                    setStateList(res?.data);
                },
                errorCallback: () => { },
            })
        );
        dispatch(
            getTDSSectionList({
                callback: (res: any) => {
                    setTdsSectionList(res?.data);
                },
                errorCallback: () => { },
            })
        );
    }, []);

    const getData = () => {
        dispatch(
            vendorList({
                callback: (res: any) => {
                    if (res?.status === "success") {
                        setVendorsList(res?.data);
                        dispatch(showSnackbar({ message: res?.msg, type: res?.status }));
                        setTimeout(() => {
                            dispatch(hideSnackbar());
                        }, 5000);
                    }
                },
                errorCallback: () => { },
            })
        );
    };
    const onChangeVendorName = (value: string) => {
        if (validateFullName(value) && !startsWithSpace(value)) {
            setVendorName(value);
        }

    };
    const onChangeGST = (value: string) => {
        if (validateIsLettersAndDigitsOnly(value) && !startsWithSpace(value)) {
            setGSTNumber(value);
        }

    };
    const onChangePAN = (value: string) => {
        if (validateIsLettersAndDigitsOnly(value) && !startsWithSpace(value)) {
            setPANNumber(value);
        }

    };
    const onChangePersonName = (value: string) => {
        if (validateFullName(value) && !startsWithSpace(value)) {
            setContactPerson(value);
        }

    };
    const onChangePersonNumber = (value: string) => {
        const onlyNumbers = /^[0-9]*$/;
        const validNumber = /^[6-9]\d{0,9}$/;
        if (!value) {
            setContactNumber(value);
            return;
        }
        if (!onlyNumbers.test(value)) {
            dispatch(showSnackbar({ message: "Please input numeric characters only", type: "error" }));
            setTimeout(() => dispatch(hideSnackbar()), 5000);
            return;
        }
        if (!validNumber.test(value)) {
            dispatch(showSnackbar({ message: "Please Enter Valid Mobile Number", type: "error" }));
            setTimeout(() => dispatch(hideSnackbar()), 5000);
            return;
        }
        setContactNumber(value);
        // if (validateDigitOnly(value) && !startsWithSpace(value)) {
        //     setContactNumber(value);
        // }

    };
    // const handleOnChangePhoneText = (e: any) => {
    //     const value = e.target.value;
    //     const onlyNumbers = /^[0-9]*$/;
    //     const validNumber = /^[6-9]\d{0,9}$/;
    //     if (!value) {
    //         setNumber(value);
    //         return;
    //     }
    //     if (!onlyNumbers.test(value)) {
    //         dispatch(showSnackbar({ message: "Please input numeric characters only", type: "error" }));
    //         setTimeout(() => dispatch(hideSnackbar()), 5000);
    //         return;
    //     }
    //     if (!validNumber.test(value)) {
    //         dispatch(showSnackbar({ message: "Please Enter Valid Mobile Number", type: "error" }));
    //         setTimeout(() => dispatch(hideSnackbar()), 5000);
    //         return;
    //     }
    //     setNumber(value);
    // };
    const onChangePersonEmail = (value: string) => {
        setContactEmail(value)

    };
    const onChangeAddressDetails = (value: string) => {
        setAddress(value)
    };
    const onChangeState = (value: any) => {
        setState(value)
        dispatch(
            getCities({
                id: value?._id,
                callback: (res: any) => {
                    setCityList(res?.data);
                },
                errorCallback: () => { },
            })
        );
    };
    const onChangeCity = (value: any) => {
        setCity(value)
    };
    const onChangeOfficialContact = (value: any) => {
        const onlyNumbers = /^[0-9]*$/;
        const validNumber = /^[6-9]\d{0,9}$/;
        if (!value) {
            setOfficialContactNumber(value);
            return;
        }
        if (!onlyNumbers.test(value)) {
            dispatch(showSnackbar({ message: "Please input numeric characters only", type: "error" }));
            setTimeout(() => dispatch(hideSnackbar()), 5000);
            return;
        }
        if (!validNumber.test(value)) {
            dispatch(showSnackbar({ message: "Please Enter Valid Mobile Number", type: "error" }));
            setTimeout(() => dispatch(hideSnackbar()), 5000);
            return;
        }
        setOfficialContactNumber(value)
    };
    const onChangeOfficialEmail = (value: any) => {
        setOfficialEmail(value);
    };
    const onChangeService = (key: any, value: any, index: any) => {
        const newArray = [...serviceArr];
        if (key === "serviceName") {
            newArray[index][key] = (value);
            setServiceArr(newArray);
        } else if (key === "TDSSection") {
            newArray[index][key] = (value);
            newArray[index]["TDSRate"] = (value?.rate);
            setServiceArr(newArray);
        } else if (key === "TDSRate") {
            newArray[index][key] = (value);
            setServiceArr(newArray);
        } else if (key === "GSTRate") {
            newArray[index][key] = (value);
            setServiceArr(newArray);
        }
    };

    const onPressAdd = () => {
        setServiceArr([...serviceArr, initialVal]);
    };
    const handleClose = (index: any) => {
        const newArrr = [...serviceArr];
        if (index > -1) {
            newArrr.splice(index, 1);
        }
        setServiceArr(newArrr);
    };

    const handleSubmit = (e: any) => {
        e.preventDefault();
        const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        const updatedServiceArr = serviceArr.map((item: any) => {
            const { _id, ...rest } = item;
            return { ...rest, TDSSection: item.TDSSection._id, GSTRate: item.GSTRate.name };
        });
        const payLoad = {
            companyName: vendorName,
            gstNumber: gstNumber,
            PAN: panNumber,
            contactPerson: {
                name: contactPerson,
                mobileNo: contactNumber,
                email: contactEmail,
            },
            addressDetails: address,
            stateId: state?._id,
            cityId: city?._id,
            contactNo: officialcontactNumber,
            email: officialEmail,
            service: updatedServiceArr,
        };
        if (!emailPattern.test(contactEmail)) {
            dispatch(showSnackbar({ message: 'Invalid contact email Address', type: 'error' }));
            setTimeout(() => {
                dispatch(hideSnackbar());
            }, 5000);
        } else if (!emailPattern.test(officialEmail)) {
            dispatch(showSnackbar({ message: 'Invalid official email address', type: 'error' }));
            setTimeout(() => {
                dispatch(hideSnackbar());
            }, 5000);
        } else {
            dispatch(
                addVendor({
                    params: payLoad,
                    callback: (res: any) => {
                        if (res?.status === "success") {
                            setVendorName("")
                            setGSTNumber("")
                            setPANNumber("")
                            setContactPerson("")
                            setContactNumber("")
                            setContactEmail("")
                            setAddress("")
                            setState("")
                            setCity("")
                            setOfficialContactNumber("")
                            setOfficialEmail("")
                            setServiceArr([initialVal]);
                            setisEditMode(false);
                            setIsAdd(false);
                            getData();
                            dispatch(showSnackbar({ message: res?.msg, type: res?.status }));
                            setTimeout(() => {
                                dispatch(hideSnackbar());
                            }, 5000);
                        }
                    },
                    errorCallback: (error: any) => {
                        dispatch(showSnackbar({ message: error?.data?.msg, type: error?.data?.type }));
                        setTimeout(() => {
                            dispatch(hideSnackbar());
                        }, 5000);
                    },
                })
            );
        }
    };
    const handleAdd = () => {
        setIsAdd(true);
        setVendorName("")
        setGSTNumber("")
        setPANNumber("")
        setContactPerson("")
        setContactNumber("")
        setContactEmail("")
        setAddress("")
        setState("")
        setCity("")
        setOfficialContactNumber("");
        setOfficialEmail("");
        setServiceArr([initialVal]);
        setVendorID("");
    };
    const handleDelete = (value: any) => {
        dispatch(
            deleteVendor({
                id: value?._id,
                callback: (res: any) => {
                    if (res?.status === "success") {
                        dispatch(showSnackbar({ message: res?.msg, type: res?.status }));
                        setTimeout(() => {
                            dispatch(hideSnackbar());
                            setisEditMode(false);
                            getData();
                        }, 5000);
                    }
                },
                errorCallback: (error: any) => {
                    dispatch(showSnackbar({ message: error?.data?.msg, type: error?.data?.status }));
                    setTimeout(() => {
                        dispatch(hideSnackbar());
                    }, 5000);
                },
            })
        );
    };

    const handleEdit = (value: any) => {
        setVendorName(value?.companyName);
        setGSTNumber(value?.gstNumber);
        setPANNumber(value?.PAN);
        setContactPerson(value?.contactPerson?.name);
        setContactNumber(value?.contactPerson?.mobileNo);
        setContactEmail(value?.contactPerson?.email);
        setAddress(value?.addressDetails);
        if (value?.stateId) {
            setState(value?.stateId);
            setCity(value?.cityId);
            dispatch(
                getCities({
                    id: value?.stateId?._id,
                    callback: (res: any) => {
                        setCityList(res?.data);
                    },
                    errorCallback: () => { },
                })
            );
        };
        setOfficialContactNumber(value?.contactNo);
        setOfficialEmail(value?.email);
        setServiceArr(value?.service);
        setVendorID(value?._id);
        setisEditMode(true);
        setIsAdd(false);
    };
    const handleGoBack = () => {
        setisEditMode(false);
        setIsAdd(false);
    };
    const handleUpdate = (e: any) => {
        e.preventDefault();
        const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        const updatedServiceArr = serviceArr.map((item: any) => {
            const { _id, ...rest } = item;
            return { ...rest, TDSSection: item.TDSSection._id, GSTRate: item.GSTRate.name ? item.GSTRate.name : item.GSTRate };
        });
        const payLoad = {
            companyName: vendorName,
            gstNumber: gstNumber,
            PAN: panNumber,
            contactPerson: {
                name: contactPerson,
                mobileNo: contactNumber,
                email: contactEmail,
            },
            addressDetails: address,
            stateId: state?._id,
            cityId: city?._id,
            contactNo: officialcontactNumber,
            email: officialEmail,
            service: updatedServiceArr,
        };
        if (!emailPattern.test(contactEmail)) {
            dispatch(showSnackbar({ message: 'Invalid contact email Address', type: 'error' }));
            setTimeout(() => {
                dispatch(hideSnackbar());
            }, 5000);
        } else if (!emailPattern.test(officialEmail)) {
            dispatch(showSnackbar({ message: 'Invalid official email address', type: 'error' }));
            setTimeout(() => {
                dispatch(hideSnackbar());
            }, 5000);
        } else {
            dispatch(
                updateVendor({
                    id: vendorID,
                    params: payLoad,
                    callback: (res: any) => {
                        if (res?.data?.status === "success") {
                            setVendorName("")
                            setGSTNumber("")
                            setPANNumber("")
                            setContactPerson("")
                            setContactNumber("")
                            setContactEmail("")
                            setAddress("")
                            setState("")
                            setCity("")
                            setOfficialContactNumber("")
                            setOfficialEmail("")
                            setServiceArr([initialVal]);
                            setisEditMode(false);
                            setIsAdd(false);
                            getData();
                            dispatch(showSnackbar({ message: res?.data?.msg, type: res?.data?.status }));
                            setTimeout(() => {
                                dispatch(hideSnackbar());
                            }, 5000);
                        }
                    },
                    errorCallback: (error: any) => {
                        dispatch(showSnackbar({ message: error?.data?.msg, type: error?.data?.type }));
                        setTimeout(() => {
                            dispatch(hideSnackbar());
                        }, 5000);
                    },
                })
            );
        }
    };
    const validations = () => {
        let valid = false;
        if (
            vendorName === "" ||
            gstNumber === "" ||
            panNumber === "" ||

            contactPerson === "" ||
            contactNumber === "" ||
            contactEmail === "" ||

            address === "" ||
            state?._id === "" ||
            city?._id === "" ||
            officialcontactNumber === "" ||
            officialEmail === "" ||
            serviceArr === 0
        ) {
            valid = true;
        }
        return valid;
    };
    const renderAddVendor = () => {
        return (
            <form onSubmit={isEditMode ? handleUpdate : handleSubmit}>
                <div className="row d-flex ">
                    <div className="col-md-4 p-2">
                        <LabelInput labelName={"Vendor Company Name"} />
                        <div className="d-flex align-items-center">
                            <div className="me-3 col-md-12">
                                <InputField
                                    key={"ex2"}
                                    placeholder={"Enter Vendor Company Name"}
                                    setInputText={(value: any) => onChangeVendorName(value)}
                                    value={vendorName}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 p-2">
                        <LabelInput labelName={"GST Number"} />
                        <div className="d-flex align-items-center">
                            <div className="me-3 col-md-12">
                                <InputField
                                    key={"ex2"}
                                    placeholder={"Enter GST Number"}
                                    setInputText={(value: any) => onChangeGST(value)}
                                    value={gstNumber.toUpperCase()}
                                    maxLength={15}
                                    minLength={2}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 p-2">
                        <LabelInput labelName={"PAN Number"} />
                        <div className="d-flex align-items-center">
                            <div className="me-3  col-md-12">
                                <InputField
                                    key={"ex2"}
                                    placeholder={"Enter PAN Number"}
                                    setInputText={(value: any) => onChangePAN(value)}
                                    value={panNumber.toUpperCase()}
                                    maxLength={10}
                                    minLength={2}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 p-2">
                        <LabelInput labelName={"Contact person Name"} />
                        <div className="d-flex align-items-center">
                            <div className="me-3 col-md-12">
                                <InputField
                                    key={"ex2"}
                                    placeholder={"Enter Contact person Name"}
                                    setInputText={(value: any) => onChangePersonName(value)}
                                    value={contactPerson}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 p-2">
                        <LabelInput labelName={"Contact person Number"} />
                        <div className="d-flex align-items-center">
                            <div className="me-3 col-md-12">
                                <InputField
                                    key={"ex2"}
                                    placeholder={"Enter Contact person Number"}
                                    setInputText={(value: any) => onChangePersonNumber(value)}
                                    value={contactNumber}
                                    maxLength={10}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 p-2">
                        <LabelInput labelName={"Contact person Email"} />
                        <div className="d-flex align-items-center">
                            <div className="me-3 col-md-12">
                                <InputField
                                    key={"ex2"}
                                    placeholder={"Enter Contact person Email"}
                                    setInputText={(value: any) => onChangePersonEmail(value)}
                                    value={contactEmail}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 p-2">
                        <LabelInput labelName={"Address Details"} />
                        <div className="d-flex align-items-center">
                            <div className="me-3 col-md-12">
                                <InputField
                                    key={"ex2"}
                                    placeholder={"Enter Address Details"}
                                    setInputText={(value: any) => onChangeAddressDetails(value)}
                                    value={address}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 p-2">
                        <LabelInput labelName={"Address state"} />
                        <div className="d-flex align-items-center">
                            <div className="me-3 col-md-12">
                                <DropDown
                                    labelName={"Select state"}
                                    setInputText={(value: any) => onChangeState(value)}
                                    options={stateList}
                                    value={state}
                                    defaultValue={state}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 p-2">
                        <LabelInput labelName={"Address city"} />
                        <div className="d-flex align-items-center">
                            <div className="me-3 col-md-12">
                                <DropDown
                                    labelName={"Select city"}
                                    setInputText={(value: any) => onChangeCity(value)}
                                    options={cityList}
                                    value={city}
                                    defaultValue={city}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 p-2">
                        <LabelInput labelName={"Official Contact Number"} />
                        <div className="d-flex align-items-center">
                            <div className="me-3 col-md-12">
                                <InputField
                                    key={"ex2"}
                                    placeholder={"Enter Official Contact Number"}
                                    setInputText={(value: any) => onChangeOfficialContact(value)}
                                    value={officialcontactNumber}
                                    maxLength={10}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 p-2">
                        <LabelInput labelName={"Official Email"} />
                        <div className="d-flex align-items-center">
                            <div className="me-3 col-md-12">
                                <InputField
                                    key={"ex2"}
                                    placeholder={"Enter Official Email"}
                                    setInputText={(value: any) => onChangeOfficialEmail(value)}
                                    value={officialEmail}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                {serviceArr.map((item: any, index: any) => {
                    const { serviceName, TDSSection, TDSRate, GSTRate } = item;
                    return (
                        <><div className="d-flex justify-content-between">
                            <div className="col-md-11">
                                <div className=" border rounded border-dark border-2 p-3 mt-3">
                                    <div className="row d-flex justify-content-between">
                                        <div className="col-md-4 p-2">
                                            <LabelInput labelName={"Service"} />
                                            <div className="d-flex align-items-center">
                                                <div className="me-3 col-md-12">
                                                    <InputField
                                                        key={"ex2"}
                                                        placeholder={"Enter Service"}
                                                        setInputText={(value: any) => onChangeService("serviceName", value, index)}
                                                        value={serviceName}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4 p-2">
                                            <LabelInput labelName={"TDS Section"} />
                                            <div className="d-flex align-items-center">
                                                <div className="me-3 col-md-12">
                                                    <DropDown
                                                        labelName={"Select TDS Section"}
                                                        setInputText={(value: any) => onChangeService("TDSSection", value, index)}
                                                        options={tdsSectionList}
                                                        value={tdsSectionList.find((item: any) => item._id === TDSSection._id)}
                                                        // value={TDSSection}
                                                        defaultValue={''}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4 p-2">
                                            <LabelInput labelName={"TDS Rate"} />
                                            <div className="d-flex align-items-center">
                                                <div className="me-3 col-md-12">
                                                    <InputField
                                                        key={"ex2"}
                                                        placeholder={"Enter TDS Rate"}
                                                        setInputText={(value: any) => onChangeService("TDSRate", value, index)}
                                                        value={TDSRate}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4 p-2">
                                            <LabelInput labelName={"GST Rate"} />
                                            <div className="d-flex align-items-center">
                                                <div className="me-3 col-md-12">
                                                    <DropDown
                                                        labelName={"Select GST Rate"}
                                                        setInputText={(value: any) => onChangeService("GSTRate", value, index)}
                                                        options={gstRateList}
                                                        value={gstRateList.find((item: any) =>
                                                            typeof GSTRate === 'object' && GSTRate !== null
                                                                ? item.id === GSTRate.id
                                                                : item.name === String(GSTRate)
                                                        )}
                                                        // value={GSTRate}
                                                        defaultValue={GSTRate}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {index === serviceArr.length - 1 && (
                                    <div className="mt-2 d-flex justify-content-end">
                                        <AddMoreBtn
                                            handleClick={onPressAdd}
                                        />
                                    </div>
                                )}
                            </div>
                            <div className="col-md-1">
                                {serviceArr.length === 1 ? null : (
                                    <DeleteForeverIcon
                                        className="cursor ms-3"
                                        color="error"
                                        fontSize="small"
                                        onClick={() => handleClose(index)}
                                    />
                                )}
                            </div>

                        </div>
                        </>
                    );
                })}
                <div className="d-flex justify-content-center">
                    <div className="col-md-3 ">
                        <Submitbtn name={isEditMode ? "Update" : "Save"} disabled={validations()} />
                    </div>
                </div>
            </form>
        )
    }
    const renderList = () => {
        return (
            <div>
                <div className="d-flex justify-content-end mb-4">
                    <button className="btn cursor cancelBtn px-5" onClick={handleAdd} >
                        Add
                    </button>
                </div>
                <div className="bxshadow p-4 borderRadius mb-4">
                    <AdminTable
                        tableData={vendorsList ? vendorsList : []}
                        pagename={"PublicationVendor"}
                        tableHead={[
                            "S.N",
                            "GST No",
                            "Company Name",
                            "Contact Person Name",
                            "Mobile No.",
                            "Pan No",
                            "State",
                            "City",
                            "Service",
                            "Action",
                        ]}
                        handleEdit={(value: any) => handleEdit(value)}
                        handleDelete={(value: { _id: string }) => handleDelete(value)}
                        edit={true}
                    />
                </div>
            </div>
        );
    };
    return (
        <div className="panel-content">
            <div className="mb-4">
                <PageTitle
                    name={"ADD VENDOR"}
                    breadCrumb={""}
                    isEditMode={isAdd || isEditMode}
                    setisEditMode={setisEditMode}
                    cancelEdit={() => handleGoBack()}
                />
            </div>
            <div className="formDiv">
                {isAdd || isEditMode ? renderAddVendor() : renderList()}
            </div>
        </div>
    );
};

export default Vendor;
